<template>
  <div class="price-range-periods">
    <div class="period-item">
      <h6>Lojas</h6>
      <mf-tooltip right>
        <template #activator="{ on }">
          <span class="pa-2" v-on="on">{{ selectedUnits.length === 1 ? '1 loja' : `${selectedUnits.length} lojas` }}</span>
        </template>
        <div>
          <span v-for="unit in selectedUnits" :key="unit.id_erp">{{ unit.name }}<br /></span>
        </div>
      </mf-tooltip>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'PriceRangeUnits',
  props: {
    filters: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters(['units']),
    selectedUnits() {
      if (!this.filters.units) return this.units
      return this.units.filter((unit) => this.filters.units?.includes(unit.id_erp))
    },
  },
}
</script>

<style lang="scss" scoped>
.price-range-periods {
  display: flex;
  gap: 10px;
  margin-bottom: 8px;
  & .input-unit {
    height: 20px;
  }
  & .period-item {
    & h6 {
      font-size: 14px;
      color: $cinza-d10;
      font-weight: bold;
      margin-bottom: 4px;
    }

    span.pa-2 {
      display: inline-block;
      color: $cinza-d10;
      min-width: 160px;
      font-size: 16px;
      font-weight: 400;
      background: $cinza-l70;
      border-radius: 4px;
    }
  }
}
</style>
